import { DateTime } from "luxon";
import { useRef, useEffect, useContext } from "react";

import { Timeline } from "@/common/components/Timeline/Timeline";
import { LiveUnitMetadataContext } from "@/common/contexts/LiveUnitMetadataContext";
import { useDispatch, RootState, useSelector } from "@/store";
import { setTimelineWidth, setTimelineStart } from "@/store/archives/slice";
import { ArchiveImagesNavMeta } from "@/utilities/types/archive";

// import { useStyles } from "./ArchiveTimeStyles";


const MINUTE = 60 * 1000;

interface ArchiveTimelineProps {
    selectedTime: DateTime | null;
}

const ArchiveTimeline: React.FC<ArchiveTimelineProps> = ({ selectedTime }) => {
    // const classes = useStyles();
    const ref = useRef<HTMLDivElement>(null);

    const unitMetadata = useContext<ArchiveImagesNavMeta>(LiveUnitMetadataContext);
    const startTime: DateTime = useSelector((state: RootState) =>
        DateTime.fromISO(state.archives.timelineStart, { zone: unitMetadata.timezone }),
    );
    const timeSpan: number = useSelector((state: RootState) => state.archives.timeSpan);
    const timeDurationMs = timeSpan * 1000;

    const dispatch = useDispatch();

    const setSourceOfTruthWidth = () => {
        const sourceOfTruthWidth = ref.current?.offsetWidth || 0;

        dispatch(setTimelineWidth(sourceOfTruthWidth));
    };

    useEffect(() => {
        window.addEventListener("load", setSourceOfTruthWidth);
        window.addEventListener("resize", setSourceOfTruthWidth);
        setSourceOfTruthWidth();

        return () => {
            window.removeEventListener("load", setSourceOfTruthWidth);
            window.removeEventListener("resize", setSourceOfTruthWidth);
        };
    }, []);

    return (
        <div>
            <Timeline
                ref={ref}
                time={startTime}
                duration={timeDurationMs}
                intervalDuration={MINUTE}
                timeUpdate={(dt: DateTime) => {
                    dispatch(setTimelineStart(dt.toISO()));
                }}
                selectedTime={selectedTime}
            />
        </div>
    );
};

export default ArchiveTimeline;
